import 'polyfill'
import './util/agGrid'
import Vue from 'vue'
import App from './App.vue'
import iView from './util/wqms-iview'
import Viewer from 'v-viewer'
import {router} from './router/index'
import 'src/assets/less/index.less'
import {AgGridVue} from 'ag-grid-vue'
import 'src/assets/less/agGridStyles/ag-grid.less'
import 'src/assets/less/agGridStyles/ag-theme-material.css'
import 'src/util/vueExtend'
import store from "./pages/store";
import Calendar from 'src/libs/element/packages/calendar/index.js';
import DataPicker from 'src/libs/element/packages/date-picker/index.js';
import Dialog from 'src/libs/element/packages/dialog/index.js';

// import { Calendar} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import  ImageResize  from 'quill-image-resize-module';
// Quill.register('modules/imageResize', ImageResize);
Vue.config.productionTip = false
Vue.use(iView)
Vue.use(Viewer)
Vue.component('AgGridVue', AgGridVue)
Vue.component(Dialog.name, Dialog)
Vue.component(Calendar.name, Calendar)
Vue.component(DataPicker.name, DataPicker)
new Vue({
	router,
	store: store,
	render: h => h(App)
}).$mount('#app')


